// Imports
import { useLenis } from 'lenis/react'
import React, { useRef, useEffect } from 'react'
import { gsap } from 'gsap'

export default function Link({navigate, children, href, ...props})
{

// Consts
    const lenis = useLenis()
    const container = document.querySelector('.container')
    const ref = useRef(null)

// Effet magnetic (sur un élément réel .magnet)
    useEffect(() => {
        const el = ref.current
        if (!el) return

        // Désactiver sur touch devices
        if (typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0)) return

        const magnet = el.querySelector('.magnet')
        if (!magnet) return

        // quickSetters pour transformer (x, y, scale) sur l'élément magnet
        const qx = gsap.quickSetter(magnet, 'x', 'px')
        const qy = gsap.quickSetter(magnet, 'y', 'px')
        const qScale = gsap.quickSetter(magnet, 'scale')

        const bounds = { w: 0, h: 0, left: 0, top: 0 }
        const updateBounds = () => {
            const r = el.getBoundingClientRect()
            bounds.w = r.width
            bounds.h = r.height
            bounds.left = r.left + window.scrollX
            bounds.top = r.top + window.scrollY
        }

        const computeMaxDist = () => Math.min(40, Math.max(12, Math.round(bounds.w * 0.12)))

        const onMove = (ev) => {
            updateBounds()
            const clientX = ev.clientX || (ev.touches && ev.touches[0] && ev.touches[0].clientX)
            const clientY = ev.clientY || (ev.touches && ev.touches[0] && ev.touches[0].clientY)
            const relX = clientX - (bounds.left + bounds.w / 2)
            const relY = clientY - (bounds.top + bounds.h / 2)

            // Normalize to -1..1
            const nx = Math.max(-1, Math.min(1, relX / (bounds.w / 2)))
            const ny = Math.max(-1, Math.min(1, relY / (bounds.h / 2)))

            const maxDist = computeMaxDist()

            // Map to px with cap
            const x = Math.round(nx * maxDist)
            const y = Math.round(ny * (maxDist * 0.5)) // moins d'effet en Y

            const scale = 1.0 + Math.abs(nx) * 0.12 + Math.abs(ny) * 0.06

            // Appliquer via quickSetter
            qx(x)
            qy(y)
            qScale(scale)
        }

        const onLeave = () => {
            gsap.to(magnet, { duration: 0.6, x: 0, y: 0, scale: 1, ease: 'power3.out' })
        }

        el.addEventListener('mousemove', onMove)
        el.addEventListener('mouseleave', onLeave)

        return () => {
            el.removeEventListener('mousemove', onMove)
            el.removeEventListener('mouseleave', onLeave)
        }
    }, [ref])

// Navigation page
    const onClick = (e) => {
        const overlay = document.getElementById('overlayTransition')

        e.preventDefault()

        overlay.classList.add('active')
        container.classList.add('active')
        setTimeout(() => {
            navigate(href) // New route
            lenis.scrollTo(0, { immediate: true })
            container.scrollTop  = 0
        }, 550)
        setTimeout(() => {
            overlay.classList.remove('active')
            container.classList.remove('active')
        }, 450)
    }

// Navigation back (attache proprement le listener dans un useEffect)
    useEffect(() => {
        const onPop = function () {
            lenis.scrollTo(0, { immediate: true })
            if (container) container.scrollTop = 0
        }
        window.addEventListener('popstate', onPop)
        return () => window.removeEventListener('popstate', onPop)
    }, [lenis, container])

    // Insère un span.magnet en première position pour que le CSS l'affecte
    return <a ref={ref} onClick={onClick} {...props} href={href} ><span className="magnet" aria-hidden="true"></span>{children}</a>
}